<template>
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2.75 8.25065L11 1.83398L19.25 8.25065V18.334C19.25 18.8202 19.0568 19.2865 18.713 19.6303C18.3692 19.9742 17.9029 20.1673 17.4167 20.1673H4.58333C4.0971 20.1673 3.63079 19.9742 3.28697 19.6303C2.94315 19.2865 2.75 18.8202 2.75 18.334V8.25065Z" 
        stroke="currentColor" stroke-opacity="0.9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M8.25 20.1667V11H13.75V20.1667" stroke="currentColor" stroke-opacity="0.9" 
            stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    

</template>
